// @ts-nocheck
import { Storage } from './setting';

const STORAGE_KEY = 'ai_agents_list';


export const AI_NAME_MAX_LENGTH = 50;

export const AGENT_TYPES = {
  VOICE: 'voice',
  CHAT: 'chat',
};

export const AGENT_TYPE_LABELS = {
  [AGENT_TYPES.VOICE]: 'Voice Agent',
  [AGENT_TYPES.CHAT]: 'Chat Agent',
};

function readAll() {
  try {
    const raw = Storage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(list) {
  Storage.setItem(STORAGE_KEY, JSON.stringify(list));
}

export function listAgents() {
  return readAll().sort((a, b) => (a.updated_at < b.updated_at ? 1 : -1));
}

export function getAgent(id) {
  return readAll().find((a) => String(a.id) === String(id)) || null;
}

export function createAgent({ name, agent_type }) {
  const list = readAll();
  const agent = {
    id: `agent_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    name,
    agent_type,
    status: 'Draft',
    updated_at: new Date().toISOString(),
  };
  list.push(agent);
  writeAll(list);
  return agent;
}

export function deleteAgent(id) {
  writeAll(readAll().filter((a) => String(a.id) !== String(id)));
}
